// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__KXKfM","cell":"ColumnAccessor_cell__2V0iH","firstCellAccent":"ColumnAccessor_firstCellAccent__2yZ5N"};